import { ChangeDetectionStrategy, Component, OnInit, effect, inject } from '@angular/core';
import { ProductoCementoApiService } from '../../../services/producto-cemento-api.service';
import { ProductosCementoStore } from '../../../stores/productos-cemento.store';
import { ProductosCementoUiEffectsService } from '../ui-effects/productos-cemento-ui-effects.service';

@Component({
  selector: 'app-productos-cemento-page',
  templateUrl: './productos-cemento-page.component.html',
  styleUrls: ['./productos-cemento-page.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ProductoCementoApiService, ProductosCementoStore, ProductosCementoUiEffectsService],
})
export class ProductosCementoPageComponent implements OnInit {
  readonly store = inject(ProductosCementoStore);
  private readonly uiEffects = inject(ProductosCementoUiEffectsService);

  constructor() {
    effect(() => {
      this.uiEffects.syncLoading(this.store.loading());
    });
  }

  ngOnInit(): void {
    this.store.loadProductos().subscribe({
      error: () => {
        this.uiEffects.showLoadError();
      },
    });
  }
}
